<div class="container-login p-2 px-3">
  <div class="d-flex align-items-center">
    <div class="col d-flex justify-content-start">
      <img
        src="../../../../assets/img/common/login-montra-logo.svg"
        class="logo-left"
        alt="Montra One"
      />
    </div>
    <div class="col d-flex justify-content-end">
      <img
        src="../../../../assets/img/common/montra-electric.svg"
        class="logo-right"
        alt="Montra Electric"
      />
    </div>
  </div>

  <div class="row me-5 mt-1">
    <div
      class="col-lg-7 d-flex flex-column justify-content-start align-items-center text-section"
    >
      <div class="heading-1">Electrifying your drive</div>
      <div class="heading-2">Maximizing your savings</div>
      <div class="heading-3">Every Mile, Every Vehicle</div>
    </div>
    <div
      class="col-lg-5 d-flex justify-content-end align-items-baseline main-container"
    >
      <div class="form-container">
        <h3 class="form-head">Create Password</h3>
        <h6 class="form-sub-head">Please enter your new password</h6>
        <p-toast></p-toast>
        @if (isExpired) {
          <p-message severity="error" [closable]="false">
            <div>
              The reset password link has expired.<br />
              Generate new reset
              <a routerLink="/verify-email" class="forgot-password">
                password link</a
              >
            </div>
          </p-message>
        }

        @if (!isExpired) {
          @for (msg of messages; track $index) {
            <p-message [severity]="$any(msg.severity)" [closable]="closable">{{
              msg.summary
            }}</p-message>
          }
        }
        <form
          *ngIf="!isExpired"
          [formGroup]="passwordForm"
          class="form-signin"
          (ngSubmit)="handleResetPassword()"
        >
          <div class="input-1">
            <span id="password" class="reauth-email"></span>
            <input
              pInputText
              [type]="showPassword?.value ? 'text' : 'password'"
              id="newPassword"
              name="newPassword"
              formControlName="newPassword"
              class="form-control"
              placeholder="New Password"
              autocomplete="off"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  passwordForm.get('newPassword')?.invalid &&
                  passwordForm.get('newPassword')?.touched,
              }"
            />
            <small
              class="p-error block"
              *ngIf="
                passwordForm.get('newPassword')?.hasError('required') &&
                passwordForm.get('newPassword')?.touched
              "
              >New Password is required</small
            >
          </div>
          <div class="input-2">
            <input
              pInputText
              [type]="showPassword?.value ? 'text' : 'password'"
              id="confirmPassword"
              name="confirmPassword"
              formControlName="confirmPassword"
              class="form-control"
              placeholder="Confirm Password"
              autocomplete="off"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  passwordForm.get('confirmPassword')?.invalid &&
                  passwordForm.get('confirmPassword')?.touched,
              }"
            />
            <small
              class="p-error block"
              *ngIf="
                passwordForm.get('confirmPassword')?.hasError('required') &&
                passwordForm.get('confirmPassword')?.touched
              "
            >
              Confirm Password is required</small
            >

            <small
              *ngIf="
                !passwordForm.get('confirmPassword')?.hasError('required') &&
                passwordForm.get('confirmPassword')?.hasError('mismatch') &&
                passwordForm.get('confirmPassword')?.touched
              "
              class="p-error block"
              >Passwords do not match</small
            >
          </div>
          <div class="input-3">
            <div id="remember" class="checkbox">
              <label class="check-box-label">
                <input
                  type="checkbox"
                  value="remember-me"
                  formControlName="showPassword"
                />
                Show Password
              </label>
            </div>
          </div>

          <button class="button-submit" type="submit" [disabled]="loading">
            {{ loading ? 'Loading...' : 'Reset' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
